<template>
  <page-view title="使用专家申请列表">
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label='综合查询' style="width: 600px">
          <a-input v-model="queryForm.queryKeyword" placeholder="招标编号|项目名称"/>
        </a-form-model-item>
        <a-form-model-item label="解密状态">
          <dict-cascader v-model="queryForm.decryptFlag" dict-key="expert_decrypt_flag"/>
        </a-form-model-item>
        <a-form-model-item label="抽取时间">
          <a-date-picker format="YYYY-MM-DD" v-model="queryForm.processStartDate" placeholder="开始日期"/>
          <span style="width: 6%;display: inline-block;text-align: center">至</span>
          <a-date-picker format="YYYY-MM-DD" v-model="queryForm.processEndDate" placeholder="结束日期"/>
        </a-form-model-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.id"
          :pagination="{ showTotal: (total) => `共 ${total} 条` }"
      >
        <template slot="projectName" slot-scope="record">
          <a @click="onView(record.id)"> {{ record.projectName }}<br>{{ record.projectCode }}</a>
        </template>
        <template slot="applyType" slot-scope="record">
          <a-tag color="red"> {{record.extras.applyTypeText}} </a-tag>
        </template>
        <template slot="applyUserName" slot-scope="record">
          {{ record.applyUserName || '未填写' }}<br>{{ record.addDate | dayjs('YYYY-MM-DD') }}
        </template>
        <template slot="processUserName" slot-scope="record">
          {{ record.processUserName }}<br>{{ record.processDate | dayjs('YYYY-MM-DD') }}
        </template>
        <template v-slot:extractResult="text,record">
          <template
              v-if="record.extras && record.extras.expertFlagNumList && record.extras.expertFlagNumList.length >0">
            <!--                        是否完成抽取-->
            <span style="color: green" v-if="getRevealByExpertFlag(record.extras.expertFlagNumList) === record.expertNumber ">已完成</span>
            <span style="color: red" v-else>未完成
               <br>
              <a-tag color="green">
              已完成{{ getRevealByExpertFlag(record.extras.expertFlagNumList) }}/{{ record.expertNumber }}人
            </a-tag>
            </span>
          </template>
          <span style="color: red"
                v-else-if="record.extras && record.extras.expertFlagNumList.length===0">未开始</span>
        </template>
        <template slot="decryptFlag" slot-scope="record">
          <a-tag  :color="DecryptFlagEnum.getValOrCol(record.decryptFlag).color">{{ DecryptFlagEnum.getValOrCol(record.decryptFlag).value }}
          </a-tag>
        </template>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import moment from 'moment'
import { QuerySelectExpertApplyList } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import DictCascader from '@/components/dict/DictCascader.vue'
import {
  ApplyStateEnum,
  DecryptFlagEnum,
  ExtractExpertFlagEnum
} from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

const columns = [
  { title: '项目名称', scopedSlots: { customRender: 'projectName' } },
  { title: '用途', align: 'center',width: '8%',scopedSlots: { customRender: 'applyType' }  },
  { title: '集合时间',align: 'center', width: '10%', dataIndex: 'setOfTime', customRender: (text) => {
    return text && moment(text).format('YYYY-MM-DD HH:mm')
    } },
  { title: '申请人', align: 'center', width: '9%',scopedSlots: { customRender: 'applyUserName' } },
  { title: '处理人', align: 'center', width: '9%', scopedSlots: { customRender: 'processUserName' } },
  {
    title: '需抽取人数', align: 'center', width: '6%', dataIndex: 'expertNumber', customRender: (text) => {
      return `${text}人`
    }
  },
  { title: '抽取结果', align: 'center', width: '8%', scopedSlots: { customRender: 'extractResult' } },
  { title: '解密状态', width: '8%', align: 'center', scopedSlots: { customRender: 'decryptFlag' }},
]
export default {
  name: 'SelectExpertApplyIndex',
  computed: {
    DecryptFlagEnum () {
      return DecryptFlagEnum
    },
    ApplyStateEnum () {
      return ApplyStateEnum
    }
  },
  components: {
    DictCascader,
    PageView,
    STable,
  },
  created () {
  },
  data () {
    return {
      columns,
      user: this.$ls.get('user'),
      queryForm: {
        queryKeyword: undefined,
        processStartDate: undefined,
        processEndDate: undefined,
        applyState: undefined,
        decryptFlag: undefined,
      },
      loadData: async parameter => {
        const params = { ...parameter, ...this.queryForm }
        return QuerySelectExpertApplyList(params)
      },
    }
  },
  activated () {
    this.refresh()
  },
  methods: {
    getRevealByExpertFlag (list) {
      let totalNum = 0
      if (list && list.length > 0) {
        list.map(item => {
          if ([ExtractExpertFlagEnum.ATTEND[0]].includes(item.expertFlag)) {
            totalNum += item.num
          }
        })
      }
      return totalNum
    },
    reset () {
      this.queryForm = {}
      this.refresh()
    },
    onSearch () {
      this.queryForm.processStartDate = this.queryForm.processStartDate && typeof this.queryForm.processStartDate === 'object' ? this.queryForm.processStartDate.format('YYYY-MM-DD') : this.queryForm.processStartDate
      this.queryForm.processEndDate = this.queryForm.processEndDate  && typeof this.queryForm.processEndDate === 'object' ? this.queryForm.processEndDate.format('YYYY-MM-DD') : this.queryForm.processEndDate
      if (this.queryForm.processEndDate < this.queryForm.processStartDate) {
        this.$message.error('结束日期不能小于开始日期')
        return
      }
      this.refresh()
    },
    refresh () {
      this.$refs.table.refresh(true)
    },
    onView (id) {
      this.$router.push({
        path: '/selectExpertApply/view?id=' + id
      })
    },
  }
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
</style>
